export default "__VITE_PUBLIC_ASSET__18b9bbb5__"